import { css } from "@emotion/core"
export const theme = {
  colors: {
    white: "#fff",
    danger: "#EF4E4E",
    text: "#fff",
    contentText: "#D9D6E5",
    purple: {
      200: "#B07DFD",
      400: "#7C41DA",
      600: "#5f56ad",
      800: "#271F4C",
      900: "#756F8E",
    },
    pink: {
      400: "#DA419F",
    },
    red: {
      400: "#EF4E4E",
    },
    grey: {
      400: "#938FA5",
    },
    brown: {
      400: "#B44D12",
    },
    black: {
      400: "#17183D",
    },
    rating: "#f4d27b",
  },
  fonts: {
    primary: "Poppins",
  },
  fontSizes: [
    "8px",
    "10px",
    "12px",
    "14px",
    "16px",
    "18px",
    "20px",
    "22px",
    "24px",
    "26px",
    "28px",
    "32px",
    "34px",
    "36px",
  ],
  lineHeights: ["21px", "30px", "44px", "60px"],
  fontWeights: { regular: "400", medium: "500", semiBold: "600", bold: "800" },
  radii: [
    "2px",
    "4px",
    "6px",
    "8px",
    "10px",
    "12px",
    "14px",
    "16px",
    "18px",
    "20px",
    "24px",
    "30px",
  ],
  gradients: {
    violetPink: "linear-gradient(91.88deg, #6713D2 15.64%, #C91885 66.7%)",
    goldBrown: "linear-gradient(353.54deg, #F4D27B 8.25%, #E7A43A 91.76%);",
    violetWhitePink: "linear-gradient(26.55deg, #7c3cff 29.21%, #1eabc3 100%);",
  },
  shadows: {
    regular: "0px 4px 4px rgba(18, 8, 33, 0.202005);",
    colorBorder: "0px 0px 6px #CA1885",
  },
  breakpoints: ["768px", "992px"],
  presets: {
    flexColumn: css`
      display: flex;
      flex-direction: column;
    `,
    flexXYCentered: css`
      display: flex;
      justify-content: center;
      align-items: center;
    `,
  },
  background: {
    modalBg: "#41337E",
    borderButton: "#16133C",
  },
}
